import styled from '@emotion/styled';
import { Button, colors, ModalActions, Typography } from '@ui-components/neo.tax';
import { ReactComponent as CheckCircle } from '@ui-components/neo.tax/dist/icons/check-circle-1.svg';
import { ReactComponent as PlusCircle } from '@ui-components/neo.tax/dist/icons/plus-circle.svg';

export const StyledButton = styled(Button)({
  display: 'inline-block',
  textAlign: 'center',
});

export const StyledPlusCircle = styled(PlusCircle)({
  height: 48,
  width: 48,
});

export const StyledSubTitle = styled(Typography)({
  paddingLeft: 24,
  paddingRight: 24,
});

export const StyledCheckCircle = styled(CheckCircle)({
  color: colors.green[400],
});

export const StyledConnectedText = styled(Typography)({
  color: colors.green[400],
});

export const StyledModalActions = styled(ModalActions)({
  paddingTop: 0,
});
